module.exports = __webpack_public_path__ + "img/wjzb_img_01.1f3e3b8b.png";